import React from 'react';

export default function SubscriptionPlans() {
  return <div>SubscriptionPlans</div>;
}
